@if (!isFirstQuestion) {
  <hr
    class="mb-7 mt-7 hr-dynamic-theme border-solid border-1 w-[20%] mx-auto"
  />
}

@if (question.conditions) {
  <div class="flex relative right-[21px] m-2">
    <div class="conditions-icon"></div>
    <app-conditions [conditions]="question.conditions"></app-conditions>
  </div>
}

<fieldset [id]="question.id">
  @if (
    question.additionalInfo && question.additionalInfo.location === "ABOVE"
  ) {
    <div
      class="mb-4 rich-text-content"
      [innerHTML]="question.additionalInfo.message | safeHtml"
    ></div>
  }

  @if (!question.hideTitle) {
    <legend
      class="font-normal title-dynamic-theme text-2xl leading-normal mb-4 contents"
    >
      @if (isMatrixQuestion ? mandatoryValue : question.mandatory) {
        <span aria-hidden="true">* </span>
        <p class="sr-only">{{ "question.requiredlabel" | translate }}</p>
      }
      <span [innerHTML]="question.title | safeHtml"></span>
    </legend>
  } @else {
    <legend class="sr-only">
      {{ question.title }}
      @if (isMatrixQuestion ? mandatoryValue : question.mandatory) {
        {{ "question.requiredlabel" | translate }}
      }
    </legend>
  }

  @if (
    question.additionalInfo && question.additionalInfo.location === "BELOW"
  ) {
    <div
      class="my-4 rich-text-content"
      [innerHTML]="question.additionalInfo.message | safeHtml"
    ></div>
  }

  <ng-content></ng-content>

  <div class="mt-1"></div>
</fieldset>
